import { IPagingDetail, PagingDetail } from "../common/request-response/paging-detail";
import { ITaxRateMasterAccountingResponse, TaxRateMasterAccountingResponse } from "../AccountingIntegration/tax-rate-master-accounting-response";


export interface IManageCategoryListRequest extends IPagingDetail {
    viewStatusType: number;
    sortColumn: string;
    isAscending: boolean;
    taxRateMasterAccountingResponse: ITaxRateMasterAccountingResponse[];
    action: number;
    OrgExpenseCategoryId: number;
    SetupType : number;
    
}

export class ManageCategoryListRequest extends PagingDetail implements IManageCategoryListRequest {
    viewStatusType: number;
    sortColumn: string;
    isAscending: boolean;
    taxRateMasterAccountingResponse: TaxRateMasterAccountingResponse[];
    action: number;
    OrgExpenseCategoryId: number;
    SetupType : number;
    constructor(viewStatusType: number, sortColumn: string, isAscending: boolean,
        sortOrder: number, pageNo: number, noOfRecords: number) {
        super();
        this.viewStatusType = viewStatusType;
        this.sortColumn = sortColumn;
        this.isAscending = isAscending;
        this.sortOrder = sortOrder;
        this.pageNo = pageNo;
        this.noOfRecords = noOfRecords;
        this.SetupType = 0;
    }
}